export default "__VITE_ASSET__Tma0vtRg__"